import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    createTextVNode as _$ct,
} from 'intact';
import {Datepicker} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Datepicker, {
            'range': true,
            'clearable': true,
            'ev-$model:value': function($v) {
                $this.set('date', $v);
            },
            'value': $this.get('date')
        }),
        _$ct('\n    You selected: '),
        JSON.stringify(this.get('date')),
        _$ce(2, 'br'),
        _$ce(2, 'br'),
        _$cc(Datepicker, {
            'range': true,
            'type': 'datetime',
            'clearable': true,
            'ev-$model:value': function($v) {
                $this.set('time', $v);
            },
            'value': $this.get('time')
        }),
        _$ct('\n    You selected: '),
        JSON.stringify(this.get('time')),
        _$ce(2, 'br'),
        _$ce(2, 'br'),
        _$cc(Datepicker, {
            'range': true,
            'type': 'year',
            'clearable': true,
            'ev-$model:value': function($v) {
                $this.set('year', $v);
            },
            'value': $this.get('year')
        }),
        _$ct('\n    You selected: '),
        JSON.stringify(this.get('year')),
        _$ce(2, 'br'),
        _$ce(2, 'br'),
        _$cc(Datepicker, {
            'range': true,
            'type': 'month',
            'clearable': true,
            'ev-$model:value': function($v) {
                $this.set('month', $v);
            },
            'value': $this.get('month')
        }),
        _$ct('\n    You selected: '),
        JSON.stringify(this.get('month')),
        _$ce(2, 'br'),
        _$ce(2, 'br')
    ], 0 /* UnknownChildren */);
};